<template>
  <div id="footer" class="container-fluid">
    <div class="footer_top">
      <div class="footer-fb">
          <a href="https://www.facebook.com/Tongits-Land-102405345689630/" target="_blank">
            <img src="@/assets/img/fb.png" class="fb-icon">&nbsp;{{ config.facebook }}
          </a>
      </div>
      <div class="footer-copy">
        <div class="copy">&copy; 2020 - {{ new Date().getFullYear() }} by {{ config.title }} |
          <router-link :to="config.cookiePolicyPath">Cookie Policy</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'

export default {
  name: "Footer",
  data() {
    return {
      config: config
    };
  }
};
</script>
<style scoped>
a, a:hover{
  color: #fff;
}
#footer {
  width: 100%;
  margin: 0;
  padding: 0;
  color: #fff;
  overflow: hidden;
}
.footer-fb{
  height: 50px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-fb::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url(../assets/img/header_bg.png);
  background-size: 100%;
  transform: scale(-1);
  -webkit-transform: scale(-1);
  -moz-transform: scale(-1);
  -ms-transform: scale(-1);
  -o-transform: scale(-1);
}
.footer-fb a {
  font-size: 16px;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.footer-fb .fb-icon {
  height: 15px;
  width: auto;
}
.footer-copy {
  height: 50px;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #1B5BA3;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .footer-fb{
    height: 50px;
  }
  .footer-fb a {
    font-size: 16px;
  }
  .footer-fb .fb-icon {
    height: 16px;
    width: auto;
  }
  .footer-copy {
    height: 50px;
    font-size: 16px;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  .footer-fb{
    height: 80px;
  }
  .footer-fb a {
    font-size: 22px;
  }
  .footer-fb .fb-icon {
    height: 22px;
    width: auto;
  }
  .footer-copy {
    height: 80px;
    font-size: 22px;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue